<template>
  <div class="h-100 company-home">
    <img
      v-if="hasCustomBackground"
      :src="`https://${portalBucket}/portal/bg_${portalId}.jpg`"
      crossorigin="anonymous"
      class="bg-company-home"
      alt="Background"
    />
    <b-jumbotron
      :header="title"
      :header-level="5"
      class="custom-jumbotron theme-jumbotron"
    >
      <p v-html="introductionText"></p>
      <p v-html="instructionText"></p>
      <p v-if="phoneServiceText" v-html="phoneServiceText"></p>

      <b-btn
        v-if="hasComplaintsModule"
        variant="primary"
        :to="`/${getRoute('report', hasAlternateComplaintForm)}`"
        size="lg"
        class="m-2 btn-complaint"
        ><i class="fas fa-file-alt" aria-hidden="true" />
        {{
          hasAlternateComplaintForm
            ? $t("home.btn.communicate")
            : $t("home.btn.report")
        }}
      </b-btn>
      <b-btn
        v-if="hasDSARModule"
        variant="primary"
        :to="`/${getRoute('data-subject-access-request')}`"
        size="lg"
        class="m-2 btn-dsar"
        ><i class="fas fa-id-card" aria-hidden="true" />
        {{ $t("home.btn.dsar") }}
      </b-btn>
      <b-btn
        v-if="hasQaSModule"
        variant="primary"
        :to="`/${getRoute('questions-and-suggestions')}`"
        size="lg"
        class="m-2 btn-qas"
        ><i class="fas fa-question" aria-hidden="true" />
        {{ $t("home.btn.qas") }}
      </b-btn>
      <b-btn
        v-if="hasOmbudsmanModule"
        variant="primary"
        :to="`/${getRoute('ombudsman')}`"
        size="lg"
        class="m-2 btn-ombudsman"
        ><i class="fa fa-user-tie" aria-hidden="true" />
        {{ $t("home.btn.ombudsman") }}
      </b-btn>
      <b-btn
        v-if="
          hasComplaintsModule ||
          hasQaSModule ||
          hasDSARModule ||
          hasOmbudsmanModule
        "
        variant="primary"
        :to="`/${getRoute('follow-up')}`"
        size="lg"
        class="m-2 btn-followup"
        ><i class="fas fa-eye" aria-hidden="true" />
        {{ $t("home.btn.followup") }}
      </b-btn>

      <div v-if="hasCustomLogo" class="logo d-none d-lg-block d-xl-block">
        <img
          :src="`https://${portalBucket}/portal/logo_${portalId}.png`"
          alt="logo"
          crossorigin="anonymous"
        />
      </div>
    </b-jumbotron>
    <!--    <b-row-->
    <!--      v-if="portalId === 'grupoeloware'"-->
    <!--      class="logo-row"-->
    <!--      align-h="center"-->
    <!--      align-content="center"-->
    <!--    >-->
    <!--      <b-col class="text-center"-->
    <!--        ><img-->
    <!--          alt="attornatus logo"-->
    <!--          :src="`https://${portalBucket}/portal/eloware/attornatus.png`"-->
    <!--          crossorigin="anonymous"-->
    <!--      /></b-col>-->
    <!--      <b-col class="text-center"-->
    <!--        ><img-->
    <!--          alt="futturis logo"-->
    <!--          :src="`https://${portalBucket}/portal/eloware/futturis.png`"-->
    <!--          crossorigin="anonymous"-->
    <!--      /></b-col>-->
    <!--      <b-col class="text-center"-->
    <!--        ><img-->
    <!--          alt="portaria logo"-->
    <!--          :src="`https://${portalBucket}/portal/eloware/portaria.png`"-->
    <!--          crossorigin="anonymous"-->
    <!--      /></b-col>-->
    <!--      <b-col class="text-center"-->
    <!--        ><img-->
    <!--          alt="projedata logo"-->
    <!--          :src="`https://${portalBucket}/portal/eloware/projedata.png`"-->
    <!--          crossorigin="anonymous"-->
    <!--      /></b-col>-->
    <!--      <b-col class="text-center"-->
    <!--        ><img-->
    <!--          alt="prothera logo"-->
    <!--          :src="`https://${portalBucket}/portal/eloware/prothera.png`"-->
    <!--          crossorigin="anonymous"-->
    <!--      /></b-col>-->
    <!--    </b-row>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Routes } from "@/i18n";

export default {
  name: "CompanyHome",
  computed: {
    ...mapGetters(["company", "portal", "portalBucket"]),
    title() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].title
      )
        return portal.languages[lang].title;
      return this.$i18n.t("home.title", [this.company.fantasyName]);
    },
    introductionText() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].introductionText
      )
        return portal.languages[lang].introductionText;
      return this.$i18n.t("home.introductionText", [this.company.fantasyName]);
    },
    instructionText() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].instructionText
      )
        return portal.languages[lang].instructionText;
      return this.$i18n.t("home.instructionText", [this.company.fantasyName]);
    },
    phoneServiceText() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].phoneServiceText
      )
        return portal.languages[lang].phoneServiceText;

      if (this.company.phoneService && this.company.phoneService.hasService) {
        const phone = this.company.phoneService.phone;
        return this.$i18n.t("home.phoneService", [phone]);
      }
      return "";
    },
    portalId() {
      return window.location.pathname
        .replace("/portal/", "")
        .replace(/\/+/g, "");
    },
    hasComplaintsModule() {
      return (
        this.company.modules.complaint && this.company.modules.complaint.enabled
      );
    },
    hasAlternateComplaintForm() {
      return (
        this.company.modules.complaint &&
        this.company.modules.complaint.alternateForm
      );
    },
    hasQaSModule() {
      return this.company.modules.qas && this.company.modules.qas.enabled;
    },
    hasDSARModule() {
      return this.company.modules.dsar && this.company.modules.dsar.enabled;
    },
    hasOmbudsmanModule() {
      return (
        this.company.modules.ombudsman && this.company.modules.ombudsman.enabled
      );
    },
    backgroundImage() {
      if (this.hasCustomBackground) {
        let bg = `url(https://s3.siscompliance.com.br/portal/bg_${this.portalId}.jpg)`;
        if (["grupogurgacz", "grupolara"].includes(this.portalId)) {
          bg = "linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.1)), " + bg;
        }
        return bg;
      }
      return "none";
    },
    hasCustomBackground() {
      return [
        "maxicredito",
        "yuny",
        "turcambio",
        "estadiomineirao",
        "insidesistemas",
        "testes",
        "tri",
        "shieldcompliance",
        "pvax-md-gusto",
        "grupoeloware",
        "fundunesp",
        "actar",
        "acicvel",
        "caixavidaeprevidencia",
        "gruposervipa",
        "grupogurgacz",
        "grupolara",
        "mcassab",
        "unimedfranca",
        "hospitalsaojoaquim",
        "docspider",
        "impa",
        "nk",
        "a3q",
        "appa",
        "lpcc",
        "cepacbarueri",
        "synergyaromas",
        "c-pack",
        "vfpapeis",
        "consilos",
        "cavalettisa",
        "fbfcanaldedenuncias",
        "somoscanaldedenuncias",
        "cplucanaldedenuncias",
      ].includes(this.portalId);
    },
    hasCustomLogo() {
      return [
        "acicvel",
        "actar",
        "caixavidaeprevidencia",
        "fundunesp",
        "grupoeloware",
        "grupogurgacz",
        "grupolara",
        "gruposervipa",
        "maxicredito",
        "estadiomineirao",
        "shieldcompliance",
        "testes",
        "tri",
        "yuny",
        "mcassab",
        "unimedfranca",
        "hospitalsaojoaquim",
        "docspider",
        "impa",
        "nk",
        "a3q",
        "appa",
        "lpcc",
        "cepacbarueri",
        "synergyaromas",
        "c-pack",
        "vfpapeis",
        "consilos",
        "cavalettisa",
        "fbfcanaldedenuncias",
        "somoscanaldedenuncias",
        "cplucanaldedenuncias",
      ].includes(this.portalId);
    },
  },
  methods: {
    getRoute(path, alt = false) {
      return Routes[`${path}${alt ? "Alt" : ""}`][this.$i18n.locale];
    },
  },
};
</script>

<style lang="scss">
.company-home {
  margin: 0 -30px;
  padding: 15px 30px 0;
  position: relative;
  overflow: hidden;
}
.bg-company-home {
  z-index: -1;
  margin: -15px -30px 0px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  aspect-ratio: auto;
  position: absolute;
  @media (max-width: 767px) {
    display: none;
  }
}

.custom-jumbotron {
  margin-top: 15px;
  border-radius: 75px;
  padding-top: 30px;
  padding-bottom: 30px;
}

.logo {
  display: inline-block;
  margin-top: 30px;
  margin-right: -30px;
  float: right;
  width: 30%;
}

.logo img {
  max-width: 100%;
}
</style>
